export default `\
#define SHADER_NAME availableAllocatedImpressionsLayer
#define HALF_PI 1.5707963268
#define PI 3.14159265359
#define TWO_PI 6.28318530718
#define TWO_AND_HALF_PI 7.85398163397
#define SMALL_CIRCLE_RADIUS_RATIO 0.15
#define SMALL_CIRCLE_ALPHA_RATIO 1.0
#define BIG_CIRCLE_ALPHA_RATIO 0.6
#define SMOOTH_MARGIN 0.05
#define IMPRESSIONS_BAR_THICKNESS_RATIO 0.01
#define ANGLE_FULL_CIRCLE 360.0
#define ANGLE_OFFSET 270.0
#define BAR_THICKNESS_MULTIPLIER 6.0
#define BACKGROUND_ALPHA 0.8

precision lowp float;

uniform bool isAvailabilityClusterVisible;
uniform bool isAllocationClusterVisible;
uniform bool isImpressionsClusterVisible;

varying vec2 unitPosition;
varying vec4 vFillColor;
varying float outerRadiusPixels;
varying float vAvailableRatio;
varying float vAllocatedRatio;
varying float vMapElementSize;
varying float vIsVisible;
varying vec4 vAssetColor;
varying vec3 vFirstBarColor;
varying vec4 vSecondBarColor;

float impressionsCircleSizeRatio = 0.4;

float angleFromCenterInDegrees() {
	float distanceFromCenter = length(unitPosition);
	float angle = mod(atan(unitPosition.y, unitPosition.x) + TWO_AND_HALF_PI, TWO_PI) - HALF_PI;
	return ANGLE_FULL_CIRCLE - mod(degrees(angle) + ANGLE_OFFSET, ANGLE_FULL_CIRCLE);
}

float smoothCircleBothSides(float ratioStart, float ratioEnd) {
	float distanceFromCenter = length(unitPosition);
	float smoothnessInnerEdge = smoothstep(ratioStart, ratioStart + SMOOTH_MARGIN, distanceFromCenter);
	float smoothnessOuterEdge = smoothstep(ratioEnd - SMOOTH_MARGIN, ratioEnd, distanceFromCenter);
	return smoothnessInnerEdge - smoothnessOuterEdge;
}

vec4 getFragColor() {
	float distanceFromCenter = length(unitPosition);
	float distanceToCircleBorder = distanceFromCenter * outerRadiusPixels;
	float inCircle = smoothedge(distanceToCircleBorder, outerRadiusPixels);
	float sizeRatio = vMapElementSize / outerRadiusPixels;

	float impressionsNotVisible = 1.0 - float(isImpressionsClusterVisible);

	float smallCircleRadiusRatio = SMALL_CIRCLE_RADIUS_RATIO * sizeRatio;
	
	impressionsCircleSizeRatio = mix(impressionsCircleSizeRatio, smallCircleRadiusRatio / sizeRatio, impressionsNotVisible);

	float innerCircleEdgeSmoothness = smoothstep(smallCircleRadiusRatio - SMOOTH_MARGIN, smallCircleRadiusRatio, distanceFromCenter);
	float outerCircleRadiusRatio = smoothstep(impressionsCircleSizeRatio * sizeRatio - SMOOTH_MARGIN, impressionsCircleSizeRatio * sizeRatio, distanceFromCenter);
	float isSmallOrBigCircleAlpha = mix(SMALL_CIRCLE_ALPHA_RATIO, BIG_CIRCLE_ALPHA_RATIO, innerCircleEdgeSmoothness);
	vec4 innerCircleColor = vec4(vAssetColor.rgb / 255.0, vAssetColor.a * isSmallOrBigCircleAlpha - outerCircleRadiusRatio);

	return innerCircleColor;
}

void main(void) {
	float isVisible = step(0.5, vIsVisible);
	vec4 fragColor = getFragColor() * isVisible;

	float shouldDiscard = step(fragColor.a, 0.0) * step(fragColor.r + fragColor.g + fragColor.b, 0.0);
	fragColor = mix(fragColor, vec4(0.0), shouldDiscard);

	gl_FragColor = fragColor;
	DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`;
